import { trpc } from '@/shared/api/trpc';

const THIRTY_SECONDS = 30 * 1000;

// Org-wide recent-activity feed for the Operations Dashboard "Recent changes"
// panel. Only fetched while the panel is open (`enabled`).
export const useRecentOperationLogData = (enabled: boolean) =>
  trpc.operationLog.findRecent.useQuery(
    { limit: 20, sinceHours: 24 },
    {
      enabled,
      staleTime: THIRTY_SECONDS,
      refetchOnMount: 'always',
    }
  );
